import { Component, signal, ViewChild, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { Popover } from 'primeng/popover';
import { PopoverModule } from 'primeng/popover';
import { UsuarioSession } from '../../../core/models/usuarioSession.model';
import { SessionService } from '../../../features/session.service';
import { TipoUsuario } from '../../../core/enums/tipoUsuario.enum';
import { TipoAreaDeInteresse } from '../../../core/enums/tipoAreaInteresse.enum';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { FormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog'; // Importação do PrimeNG
import { MensagensService } from '../service/mensagens.service';
import { ChangeDetectorRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { Button } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { cpfOuCnpjMask } from '../../utils/cpfCnpjMask';
import { LogoComponent } from '../../../features/logomarca/logomarca';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    StyleClassModule,
    AppConfigurator,
    PopoverModule,
    BadgeModule,
    OverlayBadgeModule,
    FormsModule,
    DialogModule,
    TooltipModule,
    Button,
    DatePickerModule,
    LogoComponent
  ],
  providers: [ConfirmationService],
  template: ` <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button
        class="layout-menu-button layout-topbar-action"
        (click)="layoutService.onMenuToggle()"
      >
        <i class="pi pi-bars"></i>
      </button>
      <app-logo class="layout-topbar-logo"></app-logo>
    </div>

    <div class="layout-topbar-actions">
      <div class="layout-config-menu">
        <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
          <i
            pInputText
            pTooltip="Modo Escuro"
            tooltipPosition="bottom"
            placeholder="Bottom"
            [ngClass]="{
              'pi ': true,
              'pi-moon': layoutService.isDarkTheme(),
              'pi-sun': !layoutService.isDarkTheme(),
            }"
          ></i>
        </button>
      </div>
      <app-configurator />
      <button
        class="layout-topbar-menu-button layout-topbar-action"
        pStyleClass="@next"
        enterFromClass="hidden"
        enterActiveClass="animate-scalein"
        leaveToClass="hidden"
        leaveActiveClass="animate-fadeout"
        [hideOnOutsideClick]="true"
      >
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu hidden lg:block">
        <div class="layout-topbar-menu-content">
          <button type="button" class="layout-topbar-action" (click)="toggleCalendar($event)">
            <i
              class="pi pi-calendar"
              pInputText
              pTooltip="Calendário"
              tooltipPosition="bottom"
              placeholder="Bottom"
            ></i>
          </button>

          <p-popover #calendar>
            <p-datepicker
              class="max-w-full"
              [(ngModel)]="date"
              [inline]="true"
              [showWeek]="false"
            />
          </p-popover>

          <button type="button" class="layout-topbar-action" (click)="toggleMsg($event)">
            <p-overlaybadge
              [severity]="mensagensNaoLidas?.length ? 'danger' : null"
              [value]="mensagensNaoLidas?.length ? '' : null"
              [badgeDisabled]="!mensagensNaoLidas?.length"
            >
              <div style="display: flex; align-items: center; gap: 5px;">
                <i
                  class="pi pi-inbox"
                  style="font-size: 1.3rem"
                  pInputText
                  pTooltip="Mensagens"
                  tooltipPosition="bottom"
                  placeholder="Bottom"
                ></i>
                <span>Messages</span>
              </div>
            </p-overlaybadge>
          </button>

          <p-popover #meuPopover>
            <div class="mb-3 font-medium">
              Novas Mensagens: ({{ mensagensNaoLidas?.length || 0 }})
            </div>
            <div class="overflow-y-auto" style="max-height: 300px; width: 350px;">
              <ul class="list-none p-0 m-0">
                <li
                  *ngFor="let msg of mensagensNaoLidas"
                  class="py-1 w-full"
                  (click)="lerMensagem(meuPopover, msg.isnNotificacaoUsuario)"
                >
                  <a class="link-list w-full flex" href="javascript:void(0);">
                    <i class="pi pi-envelope"></i>
                    <div class="ml-3">
                      <div [innerHTML]="(msg.dscMensagem | slice: 0 : 35) + '...'"></div>
                      <div class="w-full dsc_data">
                        {{ msg.datCadastro | date: 'dd/MM/yyyy HH:mm' }}
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </p-popover>

          <button type="button" class="layout-topbar-action" (click)="toggle($event)">
            <i
              class="pi pi-user"
              pInputText
              pTooltip="Usuário"
              tooltipPosition="bottom"
              placeholder="Bottom"
            ></i>
            <span>Profile</span>
          </button>

          <p-popover #op>
            <div class="w-72 flex flex-col gap-4">
              <!-- Header -->
              <div class="flex flex-col gap-1 border-b pb-3">
                <span class="text-sm text-surface-500">Bem-vindo</span>

                <span class="font-semibold text-base">
                  {{ formatCpfCnpj(usuario()?.dscCpfCnpj) }}
                </span>

                <span class="text-sm text-surface-500">
                  {{ usuario()?.dscEmail }}
                </span>
              </div>

              <!-- Infos -->
              <div *ngIf="usuario() as u" class="flex flex-col gap-2 text-sm">
                <div class="flex justify-between">
                  <span class="text-surface-500">Tipo</span>
                  <span class="font-medium">
                    {{ getDescricaoTipoUsuario(u.isnUsuarioTipo) }}
                  </span>
                </div>

                <div
                  class="flex justify-between"
                  *ngIf="u.isnUsuarioTipo === 3 || u.isnUsuarioTipo === 1"
                >
                  <span class="text-surface-500">Área</span>
                  <span class="font-medium">
                    {{ getDescricaoAreaInteresse(u.isnAreaInteresse) }}
                  </span>
                </div>
              </div>

              <!-- Footer -->
              <div class="pt-2 border-t border-[#dddddd] flex justify-end">
                <p-button
                  label="Sair"
                  icon="pi pi-sign-out"
                  severity="primary"
                  size="small"
                  (click)="logout()"
                >
                </p-button>
              </div>
            </div>
          </p-popover>
        </div>
      </div>
    </div>
    <p-dialog
      header="Mensagem"
      [(visible)]="visible"
      [modal]="true"
      [style]="{ width: '25rem' }"
      appendTo="body"
      (onHide)="fecharMensagem(mensagemAtiva?.isnNotificacaoUsuario)"
    >
      <p style="padding-top:10px;border-top:1px solid #ccc">
        <strong>{{ TIPOS_NOTIFICACAO[mensagemAtiva?.isnTipoNotificacaoUsuario] }}</strong>
      </p>
      <p style="font-size:12px;color:#777777">
        {{ mensagemAtiva?.datCadastro | date: 'dd/MM/yyyy HH:mm' }}
      </p>
      <p [innerHTML]="mensagemAtiva?.dscMensagem"></p>
      @if (mensagemAtiva?.codAgendamento && +mensagemAtiva.codAgendamento > 0) {
        <p>
          @if (usuario()?.isnFornecedor! < 1 && usuario()?.isnAreaInteresse! > 0) {
            <a
              [routerLink]="['/pages/agendamentoVisita']"
              [queryParams]="{ id: mensagemAtiva?.codAgendamento }"
              class="p-link"
              (click)="visible = false"
              >Ver detalhes da solicitação
            </a>
          }
          @if (usuario()?.isnFornecedor! > 0 && usuario()?.isnAreaInteresse! < 1) {
            <a
              [routerLink]="['/pages/agendamentoDetalhe']"
              [queryParams]="{ id: mensagemAtiva?.codAgendamento }"
              class="p-link"
              (click)="visible = false"
              >Ver detalhes da solicitação
            </a>
          }
        </p>
      }
      <div
        class="mt-[30px] bg-[#fffbbe] p-[5px] text-[12px] flex gap-[5px] text-black"
      >
        <i class="pi pi-exclamation-circle"></i>
        Esta mensagem também está disponível no seu e-mail.
      </div>
    </p-dialog>
  </div>`,
})
export class AppTopbar implements OnInit {
  items!: MenuItem[];
  usuario = signal<UsuarioSession | null>(null);

  private confirmationService = inject(ConfirmationService);
  private mensagensService = inject(MensagensService);
  private authService = inject(SessionService);
  date: Date[] | undefined;
  mensagemAtiva: any;
  mensagensNaoLidas: any;

  constructor(
    public layoutService: LayoutService,
    private sessionService: SessionService,
    private cd: ChangeDetectorRef,
  ) {
    this.sessionService.usuario$.subscribe((u) => this.usuario.set(u));
  }

  ngOnInit(): void {
    // console.log('Dados do Usuário logado:', this.usuario());
    // console.log('ISN do Usuário logado:', this.usuario()?.isnUsuario!);
    // console.log('ISN area de interesse:', this.usuario()?.isnAreaInteresse!);
    this.listarMensagensNovas(); //mocando isanUsuario 1
  }

  // toggleDarkMode() {
  //   this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
  // }

  toggleDarkMode() {
  this.layoutService.layoutConfig.update((state) => {
    const newValue = !state.darkTheme;

    localStorage.setItem('darkTheme', JSON.stringify(newValue)); // 👈 salva

    return { ...state, darkTheme: newValue };
  });
}

  // usado no card
  @ViewChild('op') op!: Popover;
  @ViewChild('meuPopover') msg!: Popover;
  @ViewChild('calendar') calendar!: Popover;

  toggle(event: Event) {
    this.op.toggle(event);
  }

  toggleMsg(event: Event) {
    this.msg.toggle(event);
  }

  toggleCalendar(event: Event) {
    this.calendar.toggle(event);
  }

  private readonly tipoUsuarioMap: Record<number, string> = {
    1: 'Administrador',
    2: 'Validador',
    3: 'Área de Interesse',
    4: 'Fornecedor Pessoa Física',
    5: 'Fornecedor Pessoa Jurídica',
  };

  getDescricaoTipoUsuario(tipo?: number): string {
    return this.tipoUsuarioMap[tipo ?? 0] ?? 'Não definido';
  }

  getDescricaoAreaInteresse(area: number | null | undefined): string {
    switch (area) {
      case TipoAreaDeInteresse.COMERCIAL:
        return 'Comercial';
      case TipoAreaDeInteresse.TECNICA:
        return 'Técnica';
      case TipoAreaDeInteresse.JURIDICCA:
        return 'Jurídica';
      case TipoAreaDeInteresse.FINANCEIRA:
        return 'Financeira';
      default:
        return '—';
    }
  }

  visible: boolean = false;
  isnNotificacaoUsuario: number | null = null;
  dscMensagem: string = '';
  flgLida: boolean = false;
  datCadastro: string = '';

  // Dicionário de títulos das mensagens
  readonly TIPOS_NOTIFICACAO: { [key: number]: string } = {
    1: 'Cadastro de Fornecedor',
    2: 'Documentação de Fornecedor',
    3: 'Documentação não cadastrada',
    4: 'Documentação vencida',
    5: 'Pendencia de validação de cadastro de Fornecedor',
    6: 'Atualização no cadastro de Fornecedor',
    7: 'Solicitação de agendamento de visita',
    8: 'Cancelamento de Solicitação de Agendamento de Visita Realizado',
    9: 'Confirmação de Solicitação de Agendamento de Visita',
    10: 'Indeferimento de Solicitação de Agendamento de Visita',
  };
  //--- Mostra mensagem específica
  lerMensagem(popover: any, id: number) {
    if (popover) {
      popover.hide();
    }
    this.visible = true;
    this.mensagensService.buscaMensagenEspecifica(id).subscribe({
      next: (data) => {
        // Extrai o código do agendamento da mensagem e remove codigo da tela
        const marcador = 'cod:';
        const indiceMarcador = data.dscMensagem.indexOf(marcador);
        const match = data.dscMensagem.match(/cod:(\d+)/);
        if (match) {
          data.codAgendamento = match ? match[1] : null;
          data.dscMensagem = data.dscMensagem.substring(0, indiceMarcador).trim();
        }

        setTimeout(() => {
          this.mensagemAtiva = data;
        }, 1);
      },
    });
  }

  //--- Lista mensagens não lidas
  listarMensagensNovas() {
    this.mensagensService.listarMensagensNaoLidas().subscribe({
      next: (data: any[]) => {
        // O setTimeout joga a atualização para o próximo "respiro" do navegador
        setTimeout(() => {
          this.mensagensNaoLidas = data.filter((m) => m.flgLida === false);
          //this.mensagensNaoLidas = data;
          this.cd.detectChanges();
        }, 2);
      },
    });
  }

  fecharMensagem(id: number) {
    if (!id) return; // Segurança caso o id seja nulo
    // console.log(`Mensagem ${id} marcada como lida.`);
    //1. Remove a mensagem da lista local para atualizar o contador (badge) e a lista da Topbar
    this.mensagensNaoLidas = this.mensagensNaoLidas.filter(
      (m: { isnNotificacaoUsuario: number }) => m.isnNotificacaoUsuario !== id,
    );
    //2. Limpa a mensagem ativa para resetar o estado do componente
    this.mensagemAtiva = null;
    //3. Garante que o Angular perceba a mudança no contador
    this.cd.detectChanges();
  }

  formatCpfCnpj(valor?: string): string {
    if (!valor) return '—';

    return cpfOuCnpjMask(valor);
  }

  logout() {
    this.authService.logout();
  }
}
